module.exports = __webpack_public_path__ + "img/daichao1.b6e29442.png";